/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Export_FailedInputs */

const en_us2_profile_editors_export_failed = /** @type {(inputs: Profile_Editors_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't build the file. Try again.`)
};

const pt_br2_profile_editors_export_failed = /** @type {(inputs: Profile_Editors_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para montar o arquivo. Tente de novo.`)
};

const es_419_profile_editors_export_failed = /** @type {(inputs: Profile_Editors_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo armar el archivo. Inténtalo de nuevo.`)
};

const pt_pt2_profile_editors_export_failed = /** @type {(inputs: Profile_Editors_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível preparar o ficheiro. Tenta outra vez.`)
};

const fr_fr2_profile_editors_export_failed = /** @type {(inputs: Profile_Editors_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de créer le fichier. Réessaie.`)
};

const de_de2_profile_editors_export_failed = /** @type {(inputs: Profile_Editors_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datei nicht erstellt. Versuch es noch mal.`)
};

const it_it2_profile_editors_export_failed = /** @type {(inputs: Profile_Editors_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile creare il file. Riprova.`)
};

/**
* | output |
* | --- |
* | "Couldn't build the file. Try again." |
*
* @param {Profile_Editors_Export_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_export_failed = /** @type {((inputs?: Profile_Editors_Export_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Export_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_export_failed(inputs)
	if (locale === "es-419") return es_419_profile_editors_export_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_export_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_export_failed(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_export_failed(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_export_failed(inputs)
	return en_us2_profile_editors_export_failed(inputs)
});
export { profile_editors_export_failed as "profile-editors.export_failed" }